import actionTypes from "../action-types";
import store from "store";
import commonService from "../../services/common-service";

const initialState = {
  isCustomerLoggedIn: false,
  customerInfo: {},
  isGuestFlow: false,
  isCustomerBeingRegistered: false,
  isCustomerBeingLoggedIn: false,
  customerOrders: undefined,
  isCustomerOrdersBeingFetched: false,
  isPasswordBeingUpdated: false,

  isOtpBeingSent: false,
  isOtpSent: false,
  isOtpBeingVerified: false,
  isOtpVerified: false,
  otpErrorMessage: '',

  isAddressBeingAdded: false,
  isAddressBeingRemoved: false,
  isAddressBeingUpdated: false,
  isCustomerInfoBeingUpdated: false,
};

export default function customerReducer(state = initialState, action) {
  const newState = Object.assign({}, state);
  switch (action.type) {
    case actionTypes.UPDATE_CUSTOMER_INFO: {
      newState.customerInfo = { ...action.payload };
      return newState;
    }

    case actionTypes.UPDATE_GUEST_FLOW:
      newState.isGuestFlow = action.payload;
      return newState;

    case actionTypes.UPDATE_CUSTOMER_LOGGED_IN:
      newState.isCustomerLoggedIn = action.payload;
      // newState.isGuestFlow = !action.payload;
      return newState;

    case actionTypes.IS_CUSTOMER_BEING_LOGGED_IN:
      newState.isCustomerBeingLoggedIn = action.payload;
      return newState;

    case actionTypes.IS_CUSTOMER_BEING_REGISTERED:
      newState.isCustomerBeingRegistered = action.payload;
      return newState;

    case actionTypes.IS_CUSTOMER_ORDERS_BEING_FETCHED:
      newState.isCustomerOrdersBeingFetched = action.payload;
      return newState;

    case actionTypes.UPDATE_CUSTOMER_ORDERS: {
      newState.customerOrders = [...action.payload];
      return newState;
    }

    case actionTypes.IS_PASSWORD_BEING_UPDATED: {
      newState.isPasswordBeingUpdated = action.payload;
      return newState;
    }

    case actionTypes.LOGOUT:
      store.remove("npipl_token_hash");
      newState.customerInfo = null;
      newState.isGuestFlow = true;
      newState.isCustomerLoggedIn = false;
      newState.customerOrders = [];
      newState.isCustomerOrdersBeingFetched = false;
      commonService.showNotification("success", "Logged out successfully`");
      return newState;

    case actionTypes.IS_OTP_BEING_SENT: {
      newState.isOtpBeingSent = action.payload;
      return newState;
    }

    case actionTypes.IS_OTP_SENT: {
      newState.isOtpSent = action.payload;
      return newState;
    }

    case actionTypes.IS_OTP_BEING_VERIFIED: {
      newState.isOtpBeingVerified = action.payload;
      return newState;
    }

    case actionTypes.IS_OTP_VERIFIED: {
      newState.isOtpVerified = action.payload;
      return newState;
    }
    ////////////
    case actionTypes.IS_CUSTOMER_INFO_BEING_UPDATED: {
      newState.isCustomerInfoBeingUpdated = action.payload;
      return newState;
    }

    case actionTypes.IS_ADDRESS_BEING_ADDED: {
      newState.isAddressBeingAdded = action.payload;
      return newState;
    }

    case actionTypes.IS_ADDRESS_BEING_UPDATED: {
      newState.isAddressBeingUpdated = action.payload;
      return newState;
    }

    case actionTypes.IS_ADDRESS_BEING_REMOVED: {
      newState.isAddressBeingRemoved = { ...action.payload };
      return newState;
    }

    case actionTypes.UPDATE_CUSTOMER_ADDRESS: {
      newState.customerInfo = { 
        ...newState.customerInfo,
        addresses: [...action.payload]
       };
      return newState;
    }

    case actionTypes.SET_OTP_ERROR_MESSAGE: {
      newState.otpErrorMessage = action.payload;
      return newState;
    }

    default:
      return state;
  }
}
